import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetSmartphoneFamiliesSlugQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSmartphoneFamiliesSlugQuery = { __typename?: 'query_root', b2CSmartphoneCatalog?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntity', attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', flagship?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', smartphoneFamily?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string }> }> }> }> }> }> }> }> }> }>>> }> }> }> };


export const GetSmartphoneFamiliesSlugDocument = gql`
    query getSmartphoneFamiliesSlug {
  b2CSmartphoneCatalog {
    data {
      attributes {
        catalogId
        entries {
          flagship {
            data {
              attributes {
                smartphoneVariant {
                  data {
                    attributes {
                      smartphoneFamily {
                        data {
                          attributes {
                            slug
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useGetSmartphoneFamiliesSlugQuery(baseOptions?: Apollo.QueryHookOptions<GetSmartphoneFamiliesSlugQuery, GetSmartphoneFamiliesSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmartphoneFamiliesSlugQuery, GetSmartphoneFamiliesSlugQueryVariables>(GetSmartphoneFamiliesSlugDocument, options);
      }
export function useGetSmartphoneFamiliesSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmartphoneFamiliesSlugQuery, GetSmartphoneFamiliesSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmartphoneFamiliesSlugQuery, GetSmartphoneFamiliesSlugQueryVariables>(GetSmartphoneFamiliesSlugDocument, options);
        }
export type GetSmartphoneFamiliesSlugQueryHookResult = ReturnType<typeof useGetSmartphoneFamiliesSlugQuery>;
export type GetSmartphoneFamiliesSlugLazyQueryHookResult = ReturnType<typeof useGetSmartphoneFamiliesSlugLazyQuery>;
export type GetSmartphoneFamiliesSlugQueryResult = Apollo.QueryResult<GetSmartphoneFamiliesSlugQuery, GetSmartphoneFamiliesSlugQueryVariables>;